import {
  submitFedexMfaDataInputSchema,
  submitFedexMfaDataOutputSchema,
} from "@redotech/redo-fulfillment-carrier-account-common/fedex-customer-registration";

export const submitFedexMfaData = {
  name: "submitFedexMfaData" as const,
  input: submitFedexMfaDataInputSchema,
  output: submitFedexMfaDataOutputSchema,
};
